<template>
  <i
    style="font-size: 18px; color: rgba(255, 166, 34, 1)"
    class="iconsax"
    icon-name="warning-triangle"
  ></i>
</template>
